<template>
  <div id='app'>
    <router-view v-if='isAlready'/>
    <FullscreenImg v-if='isAlready' />
    <Ball
      v-if='isAlready && showBall && !isApp()'
      :platformPower='platformPower'
    />
  </div>
</template>

<script>
import FullscreenImg from './components/common/FullscreenImg'
import Cookies from 'js-cookie'
import Ball from './components/common/Ball'
import api from '@/config/api'

export default {
  name: 'App',
  components: {
    FullscreenImg,
    Ball
  },
  data () {
    return {
      isAlready: false,
      platformPower: '',
      version: api.version,
      isMini: false
    }
  },
  created () {
    this.platformPower = this.$route.query.platformPower
    // 动态获取医院平台ID,判断具体医院平台
    if (this.$route.query.platId) {
      this.$store.commit('setPlatId', this.$route.query.platId)
      Cookies.set('platId', this.$route.query.platId, {expires: 7})
    }
    const phone = this.$route.query.phone || null // 获取手机号，注册页回显
    if (phone) {
      sessionStorage.setItem('USER-PHONE', phone)
    }

    const deptId = this.$route.query.deptId || "";
    let searchKey = this.$store.getters.searchKey
    if (deptId && deptId == '203') {
      searchKey.dept = {
        phospDeptId: deptId,
        deptName: "发热门诊"
      }
      this.$store.commit('setSearchKey', searchKey)
    } else {
      searchKey.dept = {}
      this.$store.commit('setSearchKey', searchKey)
    }
    this.initPlatform()
    var authCode = Cookies.get('authCode' + this.$store.getters.platId)

    if (this.$route.query.authCode && authCode !== this.$route.query.authCode) {
      this.$http.encryptedLogin({
        data: this.$route.query.authCode,
        secret: api.secretMap[this.$store.getters.platId]
      }).then(res => {
        console.log(this.isAlready)
        this.$store.commit('setToken', res)
        Cookies.set('authCode' + this.$store.getters.platId, this.$route.query.authCode, {expires: 7})
        Cookies.set('userToken' + this.$store.getters.platId, res, {expires: 7})
        // 判断是否对接用户体系，登出的时候要调转指定连接
        sessionStorage.setItem('LINK-SESSION', 1)
        this.getIM()
      }).catch((err) => {
        console.log(err)
        this.getIM()
      })
    } else {
      if (this.$route.query.sessionId) {
        this.$store.commit('setToken', this.$route.query.sessionId)
        Cookies.set('userToken' + this.$store.getters.platId, this.$route.query.sessionId, {expires: 7})
        // 判断是否对接用户体系，登出的时候要调转指定连接
        sessionStorage.setItem('LINK-SESSION', 1)
        //  Cookies.set('isThird ', 1, {expires: 7})
      } else {
        // 无sessionId走信息登记
        if (!this.$store.getters.token) {
          // Cookies.set('isThird ', 0, {expires: 7})
          if (this.$router.history.current.name !== 'userReg' && this.$router.history.current.name !== 'counselor' && this.$router.history.current.name !== 'deptFilter' && this.$router.history.current.name !== 'doctorInfo' && this.$router.history.current.name !== 'hospFilter') {
            this.$router.replace({ path: '/userReg', query: {platId: this.$route.query.platId} })
          }
        }
      }
      // 有token才获取IMuser信息
      this.getIM()
    }
  },
  mounted(){
    this.fontLimit();
  },
  computed: {
    showBall () {
      return this.$store.getters.showBall
    }
  },
  methods: {
    // 判断是否我们自己APP内调用
    isApp () {
      var _userAgent = navigator.userAgent
      return _userAgent.indexOf('COM_MSTPAY') > -1
    },
    URLencode (sStr) {
      return escape(sStr).replace(/%20/g, '[]')
    },
    getIM () {
      if (this.$store.getters.token) {
        this.$http.getImUser({}).then(res => {
          if (!res.userIm.imUserExtra) {
            this.$toast('该账号IM账户获取失败，请联系客服')
            return false
          }
          window.localStorage.setItem('fromIm', res.userIm.imUserExtra)

          this.$store.commit('setUserInfo', res)
          this.$store.commit('setOpenId', res.userLogin.openId)
          // 设置cookie
          Cookies.set('userId', res.user.id, {expires: 7})
          Cookies.set('userInfo', res, {expires: 7})
          Cookies.set('openId', res.userLogin.openId, {expires: 7})
          this.initHosp()
        }).catch(function (err) {
          console.log(err)
        })
      } else {
        this.initHosp()
      }
    },
    initPlatform () {
      // 判断当前所在平台
      let isMini = false
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        // 判断是否是微信环境
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            isMini = true
            this.$store.commit('setPlatform', 'mp')
          } else {
            this.$store.commit('setPlatform', 'h5')
          }
        })
      } else {
        this.$store.commit('setPlatform', 'h5')
      }
      this.isMini = isMini
    },
    fontLimit(){
      var $dom = document.createElement('div');
      $dom.style = 'font-size:10px;';
      document.body.appendChild($dom);
      // 计算出放大后的字体
      var scaledFontSize = parseInt(window.getComputedStyle($dom, null).getPropertyValue('font-size'));
      document.body.removeChild($dom);
      // 计算原字体和放大后字体的比例
      var scaleFactor = 10 / scaledFontSize;

      // 取html元素的字体大小
      // 注意，这个大小也经过缩放了
      // 所以下方计算的时候 *scaledFontSize是原来的html字体大小
      // 再次 *scaledFontSize才是我们要设置的大小
      var originRootFontSize = parseInt(window.getComputedStyle(document.documentElement, null).getPropertyValue('font-size'));
      document.documentElement.style.fontSize = originRootFontSize * scaleFactor * scaleFactor + 'px';
    },
    async initHosp () {
      // 初始化医院参数
      let res = await this.$http.initalHosp()
      // 测试使用开始
      // res['mode'] = '2'
      // 测试使用结束
      this.$store.commit('setInitHosp', res)
      this.isAlready = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue